























import { Component, Vue } from 'vue-property-decorator'
import { WEBOFFICE_DOC_URL } from '@/apps/open/constants'

@Component
export default class OnlineEditEntry extends Vue {
  services = [{
    service_name: '金山文档在线编辑',
    description: ``,
    link: 'weboffice'
  }]

  tableHeaderStyle = {
    height: '48px',
    background: '#F3F3F3',
    'text-align': 'center',
    'font-size': '18px',
    color: '#3C414B'
  }

  get curEnterprise () {
    return this.$store.getters['User/curEnterprise']
  }

  get isPassed () {
    return this.curEnterprise && this.curEnterprise.status === 1
  }

  jumpDevDoc () {
    window.open(WEBOFFICE_DOC_URL)
  }

  serviceTableRowStyle (item: any) {
    let obj: any = {
      color: '#3C414B',
      'text-align': 'center'
    }
    return obj
  }

  toWeboffice () {
    this.$router.push({ name: 'weboffice-list' })
  }
}
